import { isPlatformServer } from '@angular/common';
import { PLATFORM_ID, Pipe, PipeTransform, inject } from '@angular/core';
import { decode } from 'blurhash';

let canvas: HTMLCanvasElement;
let ctx: CanvasRenderingContext2D;
const getCanvas = () => {
  if (!canvas) {
    canvas = document.createElement('canvas');
    canvas.width = 32;
    canvas.height = 32;
    ctx = canvas.getContext('2d');
  }
  return { canvas, ctx };
};

@Pipe({
  name: 'blurHash',
  standalone: true,
  pure: true,
})
export class BlurHashPipe implements PipeTransform {
  private platformId = inject(PLATFORM_ID);

  transform(hash: string): string {
    if (!hash) return '';
    if (isPlatformServer(this.platformId)) return '';
    const { canvas, ctx } = getCanvas();

    const imageData = ctx.createImageData(32, 32);
    imageData.data.set(decode(hash, 32, 32));
    ctx.putImageData(imageData, 0, 0);

    return canvas.toDataURL();
  }
}
